// extracted by mini-css-extract-plugin
export default {"panels":"panels_panels__V5AtB","group":"panels_group__Potnz","panel":"panels_panel__7Bv5Y"};